import { store } from '../store'
import http from '../api/api'
import config from '../api/constants'

const getCurrencyValues = async () => {
  try {
    const reqParams = {
      requestId: 'GETCURRENCIES',
    }
    const response = await http.post(config.apiRoute.GET_CURRENCY_VALUES, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getExchangeRates = async ({
  buyCurrency,
  sellCurrency,
}) => {
  try {
    const { app } = store.getState()
    const reqParams = {
      buyCcy: buyCurrency,
      sellCcy: sellCurrency,
      requestId: 'CBSRATES',
      branchCode: app.profile.branchCode,
    }
    const response = await http.post(config.apiRoute.GET_EXCHANGE_RATES, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getallExchangeRates = async () => {
  try {
    const reqParams = {
      requestId: 'CROSSCURRENCYRATES',
      userName: 'TEST',
      module: 'Information',
    }
    const response = await http.post(config.apiRoute.GET_ALL_EXCHANGE_RATES, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getBuyCurrency = async (reqParams) => {
  try {
    const params = {
      requestId: 'GETBUYCURRENCY',
      ...reqParams
    }
    const response = await http.post(config.apiRoute.GET_BUYCURRENCY_VALUES, params)
    return { status: response.status, data: response.data }
  } catch (err) {

  }
}

const ExchangesRatesService = {
  getCurrencyValues,
  getExchangeRates,
  getallExchangeRates,
  getBuyCurrency
}

export default ExchangesRatesService

